export enum TaskStatus {
  CREATED = 0,
  ASSIGNED = 1,
  COMPLETED = 2,
  FAILED = 3
}

